import { ConfigurationBillableConceptResponse } from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface ConfigurationLocalAccountingRateGridConceptsModalBasicFormConcept {
    conceptId?: number
    conceptSelected: StrictNullable<ConfigurationBillableConceptResponse>
    groupConcept: StrictNullable<string>
    code: StrictNullable<string>
    unit: StrictNullable<string>
    reference: StrictNullable<string>
    alias: StrictNullable<string>
    referenceValue: number
    billableValue: number
    requiresAuthorization: boolean
    active: boolean
    hasCopayments: boolean
    copaymentValue: number
}

export interface ConfigurationLocalAccountingRateGridConceptsModalBasicFormState {
    concepts: ConfigurationBillableConceptResponse[]
    concept: ConfigurationLocalAccountingRateGridConceptsModalBasicFormConcept
    laboratoryId: number
}
export const initialLocalAccountingRateGridConceptsModalBasicFormState =
    (): ConfigurationLocalAccountingRateGridConceptsModalBasicFormState => ({
        concept: {
            conceptSelected: null,
            groupConcept: null,
            code: null,
            unit: null,
            reference: null,
            alias: null,
            referenceValue: 0,
            billableValue: 0,
            requiresAuthorization: false,
            active: true,
            hasCopayments: false,
            copaymentValue: 0
        },
        concepts: [],
        laboratoryId: store.getters.labId
    })
